import { FC } from 'react';

import { Skeleton, SkeletonCircle } from '@chakra-ui/react';

import {
  Container,
  IconWrapper,
  Content,
  RightElementContainer,
} from '../CustomRadio/styles';

export const CustomRadioLoading: FC = () => {
  return (
    <Container checked={false} hasError={false}>
      <button type="button">
        <IconWrapper>
          <SkeletonCircle />
        </IconWrapper>

        <Content>
          <div>
            <strong>
              <Skeleton height="10px" width="100px" />
            </strong>

            <p>
              <Skeleton height="10px" width="200px" />
            </p>
          </div>
        </Content>

        <RightElementContainer checked={false} hasError={false}>
          <SkeletonCircle size="4" />
        </RightElementContainer>
      </button>
    </Container>
  );
};
